import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Minus, Plus } from 'app/BargainWidget/Bargains/WidgetV1/icons/Icons';
import ErrorMessage from 'app/BargainWidget/Bargains/WidgetV1/components/forms/ErrorMessage';

const QuantityFieldV1 = ({control, label = "", placeholder = "", widgetSettings}) => {

  return (
    <Controller
      name="quantity"
      control={control}
      rules={{
        required: 'Quantity is required!',
        min: {
          value: 1,
          message: 'Quantity must be at least 1',
        },
      }}
      render={({ field: { value, onChange }, fieldState }) => (
        <div className={"bargain-widget-v1-quantity-field-block"}>
          <label style={{ '--form-label-text-color': widgetSettings?.contentFormLabelColor || '#4b5563' } as any} className="se-text-xs se-font-medium se-text-[var(--form-label-text-color)] se-mb-1.5 se-block bargain-widget-v1-input-field-label">{label}</label>
          <div className="se-flex se-items-center se-gap-3 se-bg-gray-50 se-rounded-xl se-p-2 se-transition-all se-duration-200 bargain-widget-v1-quantity-field-container">
            <div
              onClick={() => onChange(Math.max(1, value - 1))}
              className="se-cursor-pointer se-w-7 se-h-7 se-flex se-items-center se-justify-center se-rounded-lg se-bg-white se-text-gray-600 se-shadow-sm hover:se-bg-gray-50 active:se-scale-95 se-transition-transform bargain-widget-v1-quantity-field-minus-button"
            >
              <Minus className="se-w-3.5 se-h-3.5 bargain-widget-v1-quantity-field-minus-button-icon" />
            </div>
            <input
              type="number"
              value={value}
              onChange={(e) => onChange(Number(e.target.value))}
              className="se-flex-1 se-text-center se-font-medium se-text-sm se-text-gray-800 se-bg-transparent se-border-none focus:se-outline-none bargain-widget-v1-quantity-field"
              placeholder={placeholder}
              min="1"
            />
            <div
              onClick={() => onChange(value + 1)}
              className="se-cursor-pointer se-w-7 se-h-7 se-flex se-items-center se-justify-center se-rounded-lg se-bg-white se-text-gray-600 se-shadow-sm hover:se-bg-gray-50 active:se-scale-95 se-transition-transform bargain-widget-v1-quantity-field-plus-button"
            >
              <Plus className="se-w-3.5 se-h-3.5 bargain-widget-v1-quantity-field-plus-button-icon" />
            </div>
          </div>
          <ErrorMessage fieldState={fieldState} />
        </div>
      )}
    />
  );
};

export default QuantityFieldV1;
